import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { LeaseeInformation, LeasorInformation, RequestInformationLease } from "../partials/FormFieldsLease";
import { ApprenticeInformation, InvestorInformation, RequestInformationAF } from "../partials/FormFieldsAF";
import { FileGroup, TextAreaField } from "../../../components/Form/FormComponents";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import ActionSideBar from "../partials/ActionSideBar";
import { useUploadFile } from "../../../utils/useUpload";

const AwaitingProcure = ({ requestData, filter, setRequestData }) => {
	// console.log(requestData, "awaiting procure");
	const [formData, setFormData] = useState(requestData);
	const isLeasing = filter === "lease";
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";

	const miniInfo = {
		engineNum: formData?.vehicleInfo?.engineNum,
		chassisNum: formData?.vehicleInfo?.chassisNum,
		assetInvoice: formData?.assetInvoice || formData?.vehicleInfo?.assetInvoice,
		hardCopyReceipt: formData?.hardCopyReceipt || formData?.vehicleInfo?.hardCopyReceipt || null,
	};

	const [receipt, setReceipt] = useState(null);

	const handleFileUpload = (e) => setReceipt(e.target.files[0]);

	const { loading: receiptLoading, fileUploadSuccess } = useUploadFile(receipt);

	// eslint-disable-next-line no-unused-vars
	const handleCancel = () => {
		setFormData(requestData);
		setAction("view");
	};

	const updatedData = {
		lease: {
			vehicleInfo: {
				...formData?.vehicleInfo,
				hardCopyReceipt: fileUploadSuccess || miniInfo?.hardCopyReceipt,
			},
		},
	};

	const hardCopyData = {
		lease: {
			hardCopyReceipt: fileUploadSuccess || miniInfo?.hardCopyReceipt,
		},
		AfData: {
			hardCopyReceipt: fileUploadSuccess || requestData?.hardCopyReceipt,
		},
	};

	const assetRegInfo =
		formData?.productObj?.category === "Vehicles" ? updatedData?.lease : hardCopyData?.lease;

	const handleSubmit = (e) => {
		e.preventDefault();
		setRequestData(formData);
	};

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					requestData={formData}
					action={action}
					setAction={setAction}
					handleCancel={handleCancel}
					canEditStatus={true}
					isEditable={isEditable}
					options={["procured"]}
					updatedData={formData?.productObj?.category === "Vehicles" ? updatedData : hardCopyData}
					keyValue='assetRegInfo'
					assetDateToUpdate={assetRegInfo}
				/>

				<div className='RightSection'>
					<FormAccordion title='Request Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							{isLeasing ? (
								<RequestInformationLease
									formData={formData}
									isEditable={isEditable}
									fileInfo={miniInfo?.assetInvoice}
									miniInfo={miniInfo}
									receiptLoading={receiptLoading}
									handleFileUpload={handleFileUpload}
									hardCopyReceipt={fileUploadSuccess || miniInfo?.hardCopyReceipt}
									fileOneEnabled={false}
									fileTwoEnabled={isEditable}
									showDeliveryDetails
									// handleInputChange={handleInputChange}
								/>
							) : (
								<RequestInformationAF
									formData={formData}
									isEditable={isEditable}
									fileInfo={fileUploadSuccess || requestData?.paymentReceipt}
									receiptLoading={receiptLoading}
									handleFileUpload={handleFileUpload}
									hardCopyReceipt={fileUploadSuccess || requestData?.hardCopyReceipt}
									fileOneEnabled={false}
									fileTwoEnabled={isEditable}
									// handleInputChange={handleInputChange}
								/>
							)}
						</div>
					</FormAccordion>

					{isLeasing ? (
						<>
							<FormAccordion title='Product description'>
								<div className='form-group'>
									<TextAreaField
										name='product_desc'
										value={formData?.description || formData?.productId?.description}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Key features'>
								<div className='form-group'>
									<TextAreaField
										name='keyFeatures'
										value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Product specifications'>
								<div className='form-group'>
									<TextAreaField
										name='specifications'
										value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Leasor’s Information'>
								<LeasorInformation formData={formData} />
							</FormAccordion>

							<FormAccordion title='Leasee’s Information'>
								<LeaseeInformation formData={formData} />
							</FormAccordion>
						</>
					) : (
						<>
							<FormAccordion title='Proof of purchase'>
								<div className='form-group'>
									<FileGroup value={formData?.proofOfPurchaseFile?.url} />
								</div>
							</FormAccordion>

							<FormAccordion title='Investor’s Information'>
								<InvestorInformation formData={formData} />
							</FormAccordion>

							<FormAccordion title='Apprentice’s Information'>
								<ApprenticeInformation formData={formData} />
							</FormAccordion>
						</>
					)}
				</div>
			</StyledForm>
		</>
	);
};

AwaitingProcure.propTypes = {
	requestData: PropTypes.object,
	setRequestData: PropTypes.func,
	filter: PropTypes.string,
	updateCurrentObject: PropTypes.func,
};

export default AwaitingProcure;
